export const getCurrencySymbol = (code: string, local = window.navigator.language): string => {
  try {
    const formatter = new Intl.NumberFormat(local, {
      style: 'currency',
      currency: code,
    });
    const parts = formatter.formatToParts(0);
    const symbolPart = parts.find(({ type }) => type === 'currency');

    return symbolPart?.value || '';
  } catch {
    return '';
  }
};

export const getCurrencyName = (code: string, local = window.navigator.language) => {
  const displayNames = new Intl.DisplayNames([local], { type: 'currency' });
  return displayNames.of(code) || '';
};

// TODO: need to remove ts-ignore when we will update Typescript to 5.1 and fix type for it
const getAllCurrency = (): string[] => {
  // @ts-ignore
  if (typeof Intl.supportedValuesOf !== 'undefined') {
    // @ts-expect-error TS2339: Property 'supportedValuesOf' does not exist on type 'typeof Intl'.
    return Intl.supportedValuesOf('currency');
  }

  return [];
};

export const getFormattedCurrencyList = () =>
  getAllCurrency().map(currency => ({
    label: `${currency} (${getCurrencySymbol(currency)}) - ${getCurrencyName(currency)}`,
    value: currency,
  }));
